import React, { useEffect, useRef } from 'react';
import { CatMascot } from './CatMascot';
import './CartoonAuth.css';

interface AuthLayoutProps {
  children: React.ReactNode;
  catMessage: string;
  isPeeking?: boolean;
  isCoveringEyes?: boolean;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, catMessage, isPeeking, isCoveringEyes }) => {
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!bgRef.current) return;
    // Clear existing paws to prevent duplication on re-renders if strict mode
    bgRef.current.innerHTML = '';
    
    const pawEmojis = ['🐾', '🐱', '😺', '😸', '🐈'];
    for (let i = 0; i < 15; i++) {
      const paw = document.createElement('div');
      paw.className = 'floating-paw';
      paw.textContent = pawEmojis[Math.floor(Math.random() * pawEmojis.length)];
      paw.style.left = Math.random() * 100 + '%';
      paw.style.top = Math.random() * 100 + '%';
      paw.style.animationDelay = Math.random() * 5 + 's';
      paw.style.fontSize = (20 + Math.random() * 30) + 'px';
      bgRef.current.appendChild(paw);
    }
  }, []);

  return (
    <div className="cartoon-auth-page">
      <div className="background-pattern" ref={bgRef}></div>
      <div className="auth-wrapper">
        <CatMascot message={catMessage} isPeeking={isPeeking} isCoveringEyes={isCoveringEyes} />
        <div className="login-card">
          {children}
        </div>
      </div>
    </div>
  );
};
